import { render, staticRenderFns } from "./EditClinicianDetails.vue?vue&type=template&id=dc6fd9c2&"
import script from "./EditClinicianDetails.vue?vue&type=script&lang=js&"
export * from "./EditClinicianDetails.vue?vue&type=script&lang=js&"
import style0 from "./EditClinicianDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports